import { Fragment } from 'vue'

export default function flatFragment(vnodes) {
  return vnodes.map(i => {
    if (i.type === Fragment) {
      return i.children
    }
    return i
  }).flat()
}
